import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import { AuthContext } from "../../contexts/auth_provider";
import { useUser } from "../../contexts/user_provider";
import UnauthorizedPage from "../../pages/UnauthorizedPage";

const SpinnerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    width: "100%",
    height: "95vh",
    flexDirection: "column",
};

export default function AdminRoute() {
    const { user, isLoading } = useContext(AuthContext);
    const { getUserIsAdmin } = useUser();
    const location = useLocation();

    if (isLoading) {
        return (
            <div style={SpinnerStyle}>
                <img
                    src="/MyCorvus.png"
                    alt="none"
                    width="300"
                    style={{ display: "block" }}
                />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!getUserIsAdmin()) {
        return <UnauthorizedPage />;
    }

    return <Outlet />;
}
